// @ts-nocheck
// W14a — Shared state between LogradourosShell (persistent map) and sidebar routes.
// Sidebar children (List, View) publish geoJson; shell consumes para atualizar o overlay
// do SmartMap persistente.
import {
  createContext,
  useContext,
  useMemo,
  useRef,
  useState,
  type MutableRefObject,
  type ReactNode,
} from "react";

type SmartMapApi = any;

export interface LogradourosMapContextValue {
  smartMapApiRef: MutableRefObject<SmartMapApi | null>;
  /** GeoJSON do logradouro ativo (linha) ou da lista de resultados (array). */
  geoJson: unknown;
  setGeoJson: (g: unknown) => void;
  selectedId: string | null;
  setSelectedId: (id: string | null) => void;
}

const LogradourosMapContext = createContext<LogradourosMapContextValue | null>(null);

export function LogradourosMapProvider({ children }: { children: ReactNode }) {
  const smartMapApiRef = useRef<SmartMapApi | null>(null);
  const [geoJson, setGeoJson] = useState<unknown>(null);
  const [selectedId, setSelectedId] = useState<string | null>(null);

  // Memoize value so consumer useEffects depending on the whole context
  // don't fire on unrelated re-renders.
  const value = useMemo(
    () => ({ smartMapApiRef, geoJson, setGeoJson, selectedId, setSelectedId }),
    [geoJson, selectedId],
  );

  return (
    <LogradourosMapContext.Provider value={value}>
      {children}
    </LogradourosMapContext.Provider>
  );
}

export function useLogradourosMap(): LogradourosMapContextValue {
  const ctx = useContext(LogradourosMapContext);
  if (!ctx) throw new Error("useLogradourosMap must be used inside <LogradourosShell>");
  return ctx;
}

export function useOptionalLogradourosMap(): LogradourosMapContextValue | null {
  return useContext(LogradourosMapContext);
}
